import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { pie as d3Pie } from 'd3-shape';
import { scaleOrdinal as d3ScaleOrdinal } from 'd3-scale';

import Arc from './Arc';
import ClippedImage from '../ClippedImage/ClippedImage';

const CountRadius = (width, height) => {
  const viewBoxParams = {
    width: width ? width : 100,
    height: height ? height : 100
  };

  return Math.min(viewBoxParams.width, viewBoxParams.height) / 2;
};

const LabelImg = props => {
  const radius = CountRadius();
  const arcOuterRadius = radius - this.props.borderSize;
  const angle = props.endAngle - (props.endAngle - props.startAngle) * 0.2;
  const cx =
    Math.cos(angle) +
    Math.sqrt(arcOuterRadius * arcOuterRadius) * Math.sin(angle);
  const cy =
    Math.sin(angle) -
    Math.sqrt(arcOuterRadius * arcOuterRadius) * Math.cos(angle);
  return (
    <g
      className="labelImg"
      transform={`translate(${cx - props.width / 2}, ${cy - props.height / 2})`}
    >
      <ClippedImage
        width={props.width}
        height={props.height}
        borderWidth={props.data.borderWidth}
        url={props.data.img}
      />
    </g>
  );
};

export default class DonutChart extends PureComponent {
  static propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
      .isRequired,
    borderSize: PropTypes.number,
    borderColor: PropTypes.string,
    labelColor: PropTypes.string,
    labelFontSize: PropTypes.number,
    arcSize: PropTypes.number,
    dataSet: PropTypes.arrayOf(PropTypes.object).isRequired,
    showLabelImg: PropTypes.bool
  };

  static defaultProps = {
    borderSize: 10,
    borderColor: '#ffffff',
    labelColor: '#ffffff',
    labelFontSize: 20,
    arcSize: 50,
    showLabelImg: false
  };

  viewBox = {
    width: 100,
    height: 100
  };

  pie = d3Pie().value(d => d.value);
  arcs = this.pie(this.props.dataSet);

  colors = this.props.dataSet.map(d => d.color);
  color = d3ScaleOrdinal().range(this.colors);

  radius = CountRadius(this.viewBox.width, this.viewBox.height);

  render() {
    const {
      width,
      height,
      borderSize,
      arcSize,
      borderColor,
      labelColor,
      labelFontSize,
      showLabelImg
    } = this.props;

    return (
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${this.viewBox.width} ${this.viewBox.height}`}
      >
        <g
          transform={`translate(${this.viewBox.width / 2}, ${this.viewBox
            .height / 2}), scale(0.8)`}
        >
          {this.arcs.map((data, i) => (
            <Arc
              key={i}
              borderSize={borderSize}
              arcSize={arcSize}
              arcColor={this.color(i)}
              borderColor={borderColor}
              labelColor={labelColor}
              labelFontSize={labelFontSize}
              radius={this.radius}
              data={data}
            />
          ))}

          {showLabelImg &&
            this.arcs.map((data, i) => (
              <LabelImg key={`${i}_img`} {...data} width={25} height={30} />
            ))}
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/DonutChart/DonutChart.js